var React = require('react');

function IcThumbUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 10l3-6.5a3 3 0 013 3V9H18.78a1 1 0 01.98 1.196l-1.117 5.588A4 4 0 0114.721 19H7a3 3 0 01-3-3v-6h4zm2 .44V17h4.72a2 2 0 001.962-1.608L17.56 11H12V6.5a1 1 0 00-.045-.297L10 10.44zM8 12H6v4a1 1 0 001 1h1v-5z"}));
}

IcThumbUp.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = IcThumbUp;

IcThumbUp.default = IcThumbUp;
